import dayjs from "@webapp/shared/libs/dayjs";

export const transformLocalToUtcString = (date: string): string => dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
